<template>
    <!--layout1  14学术会议-->
    <div class="academic-list-section"
    >
      <div class="academic-list-section-box" @click="go(dataItem)">
        <div class="academic-list-section-box-top">
          <img :src="dataItem.cover_img" alt="" />
          <div class="academic-list-section-box-zl1" v-if="dataItem.academic_origin_type == 14">
            <img v-if="dataItem.meeting_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
            <img v-else-if="dataItem.meeting_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
            <img v-else-if="dataItem.meeting_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
          </div>
          <div class="academic-list-section-box-zl1" v-else-if="dataItem.academic_origin_type == 4">
            <img v-if="dataItem.live_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
            <img v-else-if="dataItem.live_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
            <img v-else-if="dataItem.live_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
          </div>
          <div class="academic-list-section-box-btn" v-if="dataItem.academic_origin_type == 14 && dataItem.meeting_status != 2">
            <span v-if="dataItem.isApply" class="meeting-list-box-img-btn-span1">已报名</span>
            <span v-else class="meeting-list-box-img-btn-span2" @click.stop="$router.push('/login')">报名参会</span>
          </div>
        </div>
        <div class="academic-list-section-box-title" v-html="dataItem.title"></div>
        <div class="academic-list-section-box-time">{{ dataItem.start_at }}</div>
      </div>
    </div>
</template>

<script>
import Interface from "../../../util/interface";

export default {
  name: "academic",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  methods: {
    go(item){
      console.log('item===', item)
      if (item.origin_type == 4) {
        // 直播
        this.$router.push({name: 'live-detail', params: { id: item.origin_id }})
      }else if (item.origin_type == 31) {
        // 会议
          Interface.goMeeting(this,item)
      }else if (item.origin_type == 14) {
        // 会议
          Interface.goMeeting(this,item)
      } else if (item.origin_type == 13) {
        this.$router.push({name: 'topic-detail', params: { id: item.origin_id }})
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/components/academic-list-new.scss";
.academic-list-section{
  width: 355px;
  background: #fff;
  padding: 0;
  margin: 0 auto;
  padding-bottom: 16px;
  margin-top: 10px;
  border-radius: 8px;
  &-box{
    width: 355px;
    &-top{
      position: relative;
      width: 355px;
      img{

        width: 355px;
        height: 200px;
      }
    }
    &-title{
      padding: 0 14px;
    }
    &-time{
      padding: 0 14px;
    }
    &-zl1{
      position: absolute;
      left: 0;
      top: 0;
      img{
        width: 40px;
        height: 18px;
        border-radius: 6px 2px 6px 2px;
      }
    }
    /deep/ .light {
      color: #D81D20;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout1/academic.vue